export default function*({ payload }) {
  window.open(payload.approval_url, '_self')
  yield
}